<template>
<div>
    <Breadcrumbs main="Admin" submain="System" title="Payment Log" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>Date From</span>
                                    <div class="form-group">
                                        <input type="date" class="form-control" v-model="date_from" style="width: 200px;">
                                    </div>
                                </div>
                            </div>
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>Date To</span>
                                    <div class="form-group">
                                        <input type="date" class="form-control" v-model="date_to" style="width: 200px;">
                                    </div>
                                </div>
                            </div>
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>Status</span>
                                    <div class="form-group">
                                        <b-form-select v-model="status" :options="statusOptions" style="width: 200px;"></b-form-select>
                                    </div>
                                </div>
                            </div>
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>Transaction ID</span>
                                    <div class="form-group">
                                        <b-form-input v-model="transaction_id" placeholder="Type transaction ID" style="width: 200px;"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>User Email</span>
                                    <div class="form-group">
                                        <b-form-input v-model="user_email" placeholder="Type user email" style="width: 200px;"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="grid-container mt-sm-0">
                                <div class="grid-item">
                                    <span>User ID</span>
                                    <div class="form-group">
                                        <b-form-input v-model="user_id" placeholder="Type user ID" style="width: 200px;"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div style="margin-top: 20px; display: flex; align-items: center; text-align: center; justify-content: center; color: white; background-color: #262062; padding: 2px 14px; width: 100px; border-radius: 5px; cursor: pointer; height: 39px;" @click="searchPaymentLog()">
                                <h7>Filter</h7>
                            </div>
                            <div v-if="filterShow" style="margin-top: 20px; display: flex; align-items: center; text-align: center; justify-content: center; color: white; background-color: #DC3545; padding: 2px 14px; width: 100px; border-radius: 5px; cursor: pointer; height: 39px;" @click="resetFilters()">
                                <h7>Reset</h7>
                            </div>
                        </div>

                        <div v-if="!loading && !error && !loadingPage">
                            <div class="table-responsive datatable-vue mt-3">
                                <b-table :items="payment_log" :fields="tablefields" :per-page="perPage" :filter="filter" show-empty stacked="md">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(value_a)="row">
                                        <div style="max-width: 180px;">
                                            <h7>{{ row.item.payment_response?.value_a }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(user)="row">
                                        <div style="display: flex; flex-direction: column; max-width: 200px;" v-if="row.item.user">
                                            <h7 style="font-weight: 500;">{{ row.item.user.profile?.first_name }} {{ row.item.user.profile?.last_name }}</h7>
                                            <h7>{{ row.item.user.profile?.email }}</h7>
                                            <h7>Profile ID: <span style="font-weight: 500;">{{ row.item.user.profile?.profile_id }}</span></h7>
                                            <router-link :to="{ path: '/subscription/user/wallet', query: { user_id: row.item.user?.id } }">
                                                <h7 style="padding-top: 8px; font-weight: 600; border-bottom: 2px solid #262062; width: 104px;">Wallet History</h7>
                                            </router-link>
                                        </div>
                                    </template>

                                    <template #cell(media)="row">
                                        <div style="display: flex; flex-direction: column;">
                                            <h7>Type: {{ row.item.payment_response?.card_type }}</h7>
                                            <h7>Issuer: {{ row.item.payment_response?.card_issuer }}</h7>
                                            <h7>Brand: {{ row.item.payment_response?.card_brand }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(phone_no)="row">
                                        <h7>{{ row.item.personal_info?.phone_number }}</h7>
                                    </template>

                                    <template #cell(amount)="row">
                                        <h7>{{  row.item.payment_response?.amount }}</h7>
                                    </template>

                                    <template #cell(store_amount)="row">
                                        <h7>{{  row.item.payment_response?.store_amount }}</h7>
                                    </template>

                                    <template #cell(status)="row">
                                        <div v-if="row.item.status === 'successful'">
                                            <b-badge variant="success" style="font-size: 13px; max-width: fit-content; text-transform: uppercase;">{{ row.item.status }}</b-badge>
                                        </div>
                                        <div v-if="row.item.status === 'failed'">
                                            <b-badge variant="danger" style="font-size: 13px; max-width: fit-content; text-transform: uppercase;">{{ row.item.status }}</b-badge>
                                        </div>
                                        <div v-if="row.item.status === 'cancelled'">
                                            <b-badge variant="warning" style="font-size: 13px; max-width: fit-content; text-transform: uppercase;">{{ row.item.status }}</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(gw_status)="row">
                                        <div v-if="row.item.gw_status === 'VALID'">
                                            <b-badge variant="success" style="font-size: 13px; max-width: fit-content;">{{ row.item.gw_status }}</b-badge>
                                        </div>
                                        <div v-if="row.item.gw_status === 'FAILED'">
                                            <b-badge variant="danger" style="font-size: 13px; max-width: fit-content;">{{ row.item.gw_status }}</b-badge>
                                        </div>
                                        <div v-if="row.item.gw_status === 'CANCELLED'">
                                            <b-badge variant="warning" style="font-size: 13px; max-width: fit-content;">{{ row.item.gw_status }}</b-badge>
                                        </div>
                                    </template>

                                    <template #cell(tran_date)="row">
                                        <h7 v-if="row.item.payment_response">{{ row.item?.created_on }}</h7>
                                    </template>

                                     <!-- <template #cell(action)="data">
                                        <div>
                                            <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteLog(data.item?.id)" title="Delete"></feather>
                                        </div>
                                    </template> -->
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-row class="mt-3">
                            <b-col xl="12" class="d-flex flex-wrap justify-content-between align-items-center" style="gap: 28px;">
                                <span style="display: flex; gap: 4px; min-width: fit-content;">
                                    <span>
                                        <!-- First Page Button (<<) -->
                                        <button class="pg-button" :disabled="currentPage === 1" @click="goToPage(1)">
                                            <b-icon icon="chevron-double-left"></b-icon>
                                        </button>
        
                                        <!-- Previous Page Button (<) -->
        
                                        <button class="pg-button ml-2" :disabled="currentPage === 1" @click="goToPage(currentPage - 1)">
                                            <b-icon icon="chevron-left"></b-icon>
                                        </button>
                                    </span>

                                    <!-- Page Number Display (Page X of Y) -->
                                    <span class="align-self-center">
                                        <span class="align-self-center">
                                            <span class="d-flex align-items-center" style="gap: 6px; padding: 0px 8px;">
                                                <span>Page</span>
                                                <b-form-input v-model="currentPage" style="box-shadow: none; width: 54px; text-align: center;" @blur="validatePage" @keydown.enter="validatePage" :disabled="totalPages <= 1"></b-form-input>
                                                <span>of {{ totalPages }}</span>
                                            </span>
                                        </span>
                                    </span>

                                    <span>
                                        <!-- Next Page Button (>) -->
                                        <button class="mr-2 pg-button" :disabled="currentPage === totalPages" @click="goToPage(currentPage + 1)">
                                            <b-icon icon="chevron-right"></b-icon>
                                        </button>
        
                                        <!-- Last Page Button (>>) -->
                                        <button class="pg-button" :disabled="currentPage === totalPages" @click="goToPage(totalPages)">
                                            <b-icon icon="chevron-double-right"></b-icon>
                                        </button>
                                    </span>
                                </span>

                                <div style="min-width: 200px; display: flex; align-items: center;">
                                    <span style="width: 160px;">Per page:</span> <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- User Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this log?</div>
    </b-modal>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { myHost } from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';
import Multiselect from 'vue-multiselect';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader,
        Multiselect
    },

    data() {
        return {
            host: myHost.host,
            selected: [],
            isDisabled: false,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'user',
                    label: 'User',
                    sortable: true
                },
                {
                    key: 'value_a',
                    label: 'Request ID',
                    sortable: true
                },
                {
                    key: 'media',
                    label: 'Media / Channel', 
                    sortable: true
                },
                {
                    key: 'amount',
                    label: 'Amount',
                    sortable: true
                },
                {
                    key: 'store_amount',
                    label: 'Store Amount',
                    sortable: true
                },
                {
                    key: 'transaction_id',
                    label: 'Transaction ID',
                    sortable: true
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true
                },
                {
                    key: 'gw_status',
                    label: 'GW Status',
                    sortable: true
                },
                {
                    key: 'tran_date',
                    label: 'Transaction Date',
                    sortable: true
                },
                // {
                //     key: 'action',
                //     label: 'Action',
                //     sortable: true
                // }
            ],
            initialLoad: true,
            filterShow: false,
            status: null,
            transaction_id: null,
            date_from: null,
            date_to: null,
            user_email: null,
            user_id: null,
            filter: null,
            delete_value: null,
            statusOptions: [
                { value: null, text: 'Select Status' },
                { value: 'successful', text: 'Successful' },
                { value: 'failed', text: 'Failed' },
                { value: 'cancelled', text: 'Cancelled' }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 25,
            loadingPage: false,
            pageOptions: [25, 50, 100]
        };
    },

    computed: {
        ...mapState({
            payment_log: state => state.payment.payment_log,
            loading: state => state.payment.paymentLoading,
            error: state => state.payment.paymentError,
            count: state => state.payment.payment_log_count
        }),

        totalPages() {
            if (typeof this.totalRows === 'number' && !isNaN(this.totalRows) && this.totalRows > 0) {
                return Math.ceil(this.totalRows / this.perPage);
            }
            return 1; // Default to 1 if totalRows is invalid
        }
    },

    watch: {
        currentPage(newCurrentPage) {
            if (!this.initialLoad) {
                if (this.currentPage === null || this.currentPage === '') {
                    this.loadingPage = true
                }
                
                this.$router.replace({
                    path: '/system/payment-log',
                    query: {
                        page: newCurrentPage,
                        perPage: this.perPage
                    }
                });
                
                this.currentPage = newCurrentPage
                this.$store.dispatch("payment/fetchPaymentLog", {
                    perPage: this.perPage,
                    currentPage: newCurrentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        },

        perPage(newperPage) {
            if (!this.initialLoad) {
                
                this.$router.replace({
                    path: '/system/payment-log',
                    query: {
                        page: this.currentPage,
                        perPage: newperPage
                    }
                });

                this.perPage = newperPage
                this.$store.dispatch("payment/fetchPaymentLog", {
                    perPage: newperPage,
                    currentPage: this.currentPage
                }).then(() => {
                    this.totalRows = this.count;
                    this.initialLoad = false
                });
            }
        }
    },

    mounted() {
        if (this.initialLoad) {
            if (!this.$route.query.page || !this.$route.query.perPage) {
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        page: this.currentPage,
                        perPage: this.perPage
                    }
                }).catch(err => {
                    if (err.name !== 'NavigationDuplicated') {
                        throw err;
                    }
                });
                this.fetchInitial();
            } else {
                this.currentPage = parseInt(this.$route.query.page);
                this.perPage = parseInt(this.$route.query.perPage);
                this.fetchInitial();
            }
        }
    },

    methods: {
        validatePage() {
            this.loadingPage = true;
            const totalPages = this.totalPages;
            
            if (!this.currentPage || isNaN(this.currentPage) || this.currentPage < 1) {
                this.currentPage = 1;
            } else if (Number(this.currentPage) > totalPages) {
                this.currentPage = totalPages; // Set to last valid page
            }

            this.loadingPage = false;
        },

        goToPage(page) {
            if (page < 1 || page > this.totalPages) return;
            this.currentPage = page;
        },

      formatDate(dateStr) {
            if (!dateStr) return ''

            // Split date and time manually
            const [datePart, timePart] = dateStr.replace('Z', '').split('T')

            const [year, month, day] = datePart.split('-')
            const [hourRaw, minute] = timePart.split(':')

            const hours = parseInt(hourRaw)

            const monthNames = [
                'January', 'February', 'March', 'April', 'May', 'June',
                'July', 'August', 'September', 'October', 'November', 'December'
            ]

            const monthName = monthNames[parseInt(month) - 1]

            const ampm = hours >= 12 ? 'PM' : 'AM'
            const hour12 = hours % 12 || 12

            const getOrdinal = (n) => {
                const s = ['th', 'st', 'nd', 'rd']
                const v = n % 100
                return s[(v - 20) % 10] || s[v] || s[0]
            }

            return {
                date: `${parseInt(day)}${getOrdinal(parseInt(day))} ${monthName}, ${year}`,
                time: `${hour12}:${minute} ${ampm}`
            }
        },

        fetchInitial() {
            this.$store.dispatch("payment/fetchPaymentLog", {
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(() => {
                this.totalRows = this.count;
                this.initialLoad = false;
            });
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetFilters() {
            this.filterShow = false;
            this.status = null;
            this.transaction_id = null;
            this.date_from = null;
            this.date_to = null;
            this.user_email = null;
            this.user_id = null;
            this.$router.replace({
                path: '/system/payment-log',
                query: {
                    page: this.currentPage,
                    perPage: this.perPage
                }
            });
            this.fetchInitial();
        },

        searchPaymentLog() {
            this.filterShow = true;
            this.$store.dispatch("payment/fetchPaymentLog", {
                perPage: this.perPage,
                currentPage: this.currentPage,
                status: this.status,
                transaction_id: this.transaction_id,
                date_from: this.date_from,
                date_to: this.date_to,
                user_email: this.user_email,
                user_id: this.user_id
            }).then(() => {
                this.totalRows = this.count;
                this.currentPage = 1;
            });
        },

        deleteLog(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("payment/deletePaymentLog", {
                delete: this.delete_value,
                perPage: this.$route.query.perPage,
                currentPage: this.$route.query.page
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.message,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>

<style scoped>
.table-danger {
    background-color: #f8d7da !important;
    color: #721c24 !important;
}
</style>
